(function () {
  document.querySelectorAll("[data-hero]").forEach(function (root) {
    var img = root.querySelector(".js-hero-img");
    root.querySelectorAll(".js-thumb").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll(".js-thumb").forEach(function (b) { b.classList.remove("is-on"); });
        btn.classList.add("is-on");
        if (img && btn.dataset.src) img.src = btn.dataset.src;
      });
    });
    var form = root.querySelector(".js-atc");
    var variant = root.querySelector(".js-variant");
    var labels = document.querySelectorAll(".js-atc-btn");
    function sync() {
      var on = root.querySelector(".kit input:checked");
      if (!on) return;
      if (variant) variant.value = on.value || "";
      var name = on.dataset.name || "kit";
      var price = on.dataset.price || "";
      labels.forEach(function (b) {
        b.textContent = "Add " + name + (price ? " · $" + price : "");
      });
    }
    root.querySelectorAll(".kit").forEach(function (kit) {
      kit.addEventListener("click", function () {
        root.querySelectorAll(".kit").forEach(function (k) { k.classList.remove("is-on"); });
        kit.classList.add("is-on");
        var radio = kit.querySelector("input");
        if (radio) radio.checked = true;
        sync();
      });
    });
    sync();
    document.querySelectorAll(".sticky-atc .js-atc-btn").forEach(function (b) {
      b.addEventListener("click", function () {
        if (form) form.requestSubmit();
      });
    });
  });

  document.querySelectorAll("[data-tools]").forEach(function (root) {
    var img = root.querySelector(".js-tool-img");
    root.querySelectorAll(".js-tool").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll(".js-tool").forEach(function (b) { b.classList.remove("is-on"); });
        btn.classList.add("is-on");
        if (img && btn.dataset.src) img.src = btn.dataset.src;
      });
    });
  });

  document.querySelectorAll("[data-faq] .item button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.parentElement;
      item.classList.toggle("is-on");
    });
  });

  document.querySelectorAll("[data-fit]").forEach(function (root) {
    var range = root.querySelector(".js-height");
    var h = root.querySelector(".js-h");
    var p = root.querySelector(".js-p");
    var ext = root.querySelector(".js-ext");
    var copy = root.querySelector(".js-ext-copy");
    var qtyInput = root.querySelector(".js-ext-qty");
    var btn = root.querySelector(".js-ext-btn");
    var max = Number(root.dataset.max || 48);
    var trigger = Number(root.dataset.trigger || 71);
    var price = Number(root.dataset.price || 24);
    var qty = Number(root.dataset.qty || 2);
    function upd() {
      var height = Number(range.value);
      var ideal = Math.round(height * 0.68);
      var pole = Math.min(max, Math.max(26, ideal));
      var ft = Math.floor(height / 12);
      var inch = height % 12;
      if (h) h.textContent = height + " in · " + ft + "'" + inch + '"';
      if (p) p.textContent = String(pole);
      var show = height >= trigger;
      if (ext) ext.hidden = !show;
      if (show && copy) {
        copy.textContent = "You need " + ideal + " in. The pole stops at " + max + ".";
      }
      if (qtyInput) qtyInput.value = String(qty);
      if (btn) {
        var total = price * qty;
        btn.textContent = "Add " + qty + " extension" + (qty > 1 ? "s" : "") + " · $" + total;
      }
    }
    if (range) range.addEventListener("input", upd);
    upd();
  });
})();
